import { ThumbsUp, ThumbsDown, MessageCircle, Share2 } from 'lucide-react';
import { FaYoutube } from 'react-icons/fa';
import { PreviewCardShell } from './PreviewCardShell';

interface YouTubeShortMockupProps {
  title?: string;
  hook?: string;
  views?: string;
  likes?: string;
  comments?: string;
  channelName?: string;
  previewLabel?: string;
  hideShell?: boolean;
}

export const YouTubeShortMockup = ({
  title = 'Short title',
  hook,
  views = '0',
  likes = '0',
  comments = '0',
  channelName = '@channel',
  previewLabel = 'YouTube Shorts Preview',
  hideShell = false,
}: YouTubeShortMockupProps) => {
  const content = (
    <div className="relative bg-gradient-to-br from-red-900 to-zinc-900" style={{ aspectRatio: '9/16' }}>
      {/* Hook text at top if provided */}
      {hook && (
        <div className="absolute top-4 left-4 right-16 z-10">
          <p className="text-white text-lg font-bold drop-shadow-lg line-clamp-2">{hook}</p>
        </div>
      )}

      {/* Right sidebar actions */}
      <div className="absolute right-2 bottom-28 flex flex-col gap-4 items-center">
        <div className="flex flex-col items-center">
          <div className="w-10 h-10 rounded-full bg-zinc-800/70 flex items-center justify-center mb-1">
            <ThumbsUp className="w-5 h-5 text-white" />
          </div>
          <span className="text-white text-xs font-semibold">{likes}</span>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-10 h-10 rounded-full bg-zinc-800/70 flex items-center justify-center mb-1">
            <ThumbsDown className="w-5 h-5 text-white" />
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-10 h-10 rounded-full bg-zinc-800/70 flex items-center justify-center mb-1">
            <MessageCircle className="w-5 h-5 text-white" />
          </div>
          <span className="text-white text-xs font-semibold">{comments}</span>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-10 h-10 rounded-full bg-zinc-800/70 flex items-center justify-center">
            <Share2 className="w-5 h-5 text-white" />
          </div>
        </div>
      </div>

      {/* Bottom info area */}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-8">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-red-400 to-red-600" />
          <span className="text-white font-semibold text-sm">{channelName}</span>
          <button className="ml-auto bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full opacity-60 cursor-not-allowed">
            Subscribe
          </button>
        </div>
        <p className="text-white text-sm font-semibold line-clamp-2 mb-1">{title}</p>
        <div className="text-zinc-300 text-xs">{views} views</div>
      </div>
    </div>
  );

  if (hideShell) {
    return content;
  }

  return (
    <PreviewCardShell
      className="mx-auto mb-3 w-full max-w-sm"
      badgeClassName="bg-[#FF0000]"
      badge={<FaYoutube className="h-5 w-5 text-white" />}
      label={previewLabel}
    >
      {content}
    </PreviewCardShell>
  );
};
